import React from "react";
import OfferTemplatePage from "./../pages/OfferTemplatePage";

const OfferShortPage = () => {
  return <OfferTemplatePage type="short" />;
};

export default OfferShortPage;
